function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDiscount = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 11,
  viewBox: "0 0 10 11",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  "data-name": "\\uADF8\\uB8F9 230"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uB2E4\\uAC01\\uD615 3",
  d: "m5 0 5 6H0z",
  transform: "rotate(180 5 5.5)",
  style: {
    fill: "#ff7474"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uC0AC\\uAC01\\uD615 213",
  transform: "translate(2)",
  style: {
    fill: "#ff7474"
  },
  d: "M0 0h6v7H0z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDiscount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "a02679c7a7b87467d6449ab1cd3c1511.svg";